import React, { useState } from 'react';
import { UncontrolledTooltip, Button } from 'reactstrap';
import ViewMessageModal from './ViewMessageModal';
import { getMessagePreview, isMessageTruncated } from './whatsappMessageUtils';

const WhatsAppMessageCell = ({ message, rowId, context = {} }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const fullText = message || '';
  const preview = getMessagePreview(fullText);
  const truncated = isMessageTruncated(fullText);
  const tooltipTargetId = `wa-msg-${rowId}`;

  if (!fullText) {
    return '—';
  }

  return (
    <>
      <span
        id={truncated ? tooltipTargetId : undefined}
        style={{ cursor: truncated ? 'help' : undefined, wordBreak: 'break-word' }}
      >
        {preview}
      </span>
      {truncated && (
        <>
          <UncontrolledTooltip placement="top" target={tooltipTargetId} fade={false}>
            <div
              className="text-start"
              style={{
                maxWidth: 'min(360px, 80vw)',
                maxHeight: '200px',
                overflowY: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
              }}
            >
              {fullText}
            </div>
          </UncontrolledTooltip>
          <Button
            color="link"
            className="p-0 ms-1 align-baseline"
            style={{ fontSize: '0.85rem' }}
            onClick={() => setModalOpen(true)}
          >
            View
          </Button>
          <ViewMessageModal
            isOpen={modalOpen}
            handleClose={() => setModalOpen(false)}
            message={fullText}
            context={context}
          />
        </>
      )}
    </>
  );
};

export default WhatsAppMessageCell;
